module.exports = __webpack_public_path__ + "static/img/modelDetails4.40f978b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/modelDetails4.png
// module id = k4LB
// module chunks = 1